module.exports = __webpack_public_path__ + "img/measure_ov.3ef1a3e6.png";